import React, { useState } from 'react';
import {
  CattleNvdWrapper,
  FormSection,
  CheckboxGroup,
  CheckboxItem,
  ButtonsWrapper,
  FormButton,
  DeclarationText,
  FormHeader,
  FormTitle,
  TwoColumns,
  FormField,
  CattleTable,
  TableWrapper,
  QuestionGroup,
  QuestionLabel,
  RadioGroup,
  DeclarationContainer,
  OutlineButton,
  FormTopHeader,
  // ProgressIndicator,
} from './cattleNvd.style';

const BobbyCalvesNvd = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    // NVD Number
    nvdNumber: '',

    // Owner/calves details
    ownerName: '',
    fullTradingName: '',
    propertyAddress: '',
    propertyTown: '',
    propertyState: '',
    propertyPostcode: '',
    propertyPIC: '',

    // Calves description
    calvesDescription: [{ number: '', description: '' }],

    // Consignment details
    consignedTo: '',
    destinationAddress: '',
    destinationTown: '',
    destinationState: '',
    destinationDifferent: '',
    destinationPIC: '',

    // Statutory documents
    documentType: '',
    documentNumber: '',
    officeOfIssue: '',
    expiryDate: '',

    // Questions
    licensedDairyFarm: '', // Question 1
    programDetails: '',
    ownershipSinceBirth: '', // Question 2
    timeObtained: '', // If No to Q2
    materialConsumed60Days: '', // Question 3
    chemicalProduct: '',
    dateApplied: '',
    grazingDate: '',
    dateFirstPastured: '',
    dateFeedingCeased: '',
    oralTreatment: '', // Question 4
    veterinaryDrugDetails: '',
    caseNumber: '',
    dateList: '',
    milkAccess: '', // Question 5
    vetDrugChemical: '',
    dateCalf: '',
    milkWithheld: '',
    cowDays: '',
    esiOrSet: '',
    chemicalResidues6Months: '', // Question 6
    residueDetails: '',
    additionalInfo: '', // Question 7

    // Declaration
    declarantName: '',
    declarantAddress: '',
    phone: '',
    fax: '',
    email: '',
    signature: '',
    date: '',

    // Part B - Transport details
    movementCommenced: '',
    vehicleRegistration: '',
    transporterName: '',
    transporterSignature: '',
    transporterDate: '',
    transporterTelNo: '',
  });

  const steps = [
    'NVD & Owner Details',
    'Calves Description',
    'Consignment Details',
    'Statutory Documents',
    'Part A - Questions 1-2',
    'Part A - Questions 3-4',
    'Part A - Questions 5-7',
    'Declaration',
    'Part B - Transport',
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCalvesDescriptionChange = (index, field, value) => {
    const newCalvesDescription = [...formData.calvesDescription];
    newCalvesDescription[index] = {
      ...newCalvesDescription[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      calvesDescription: newCalvesDescription,
    }));
  };

  const addCalvesRow = () => {
    setFormData((prev) => ({
      ...prev,
      calvesDescription: [...prev.calvesDescription, { number: '', description: '' }],
    }));
  };

  const removeCalvesRow = (index) => {
    if (formData.calvesDescription.length > 1) {
      setFormData((prev) => ({
        ...prev,
        calvesDescription: prev.calvesDescription.filter((_, i) => i !== index),
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Bobby Calves NVD Form Data:', formData);
    // Handle form submission here
    alert('Bobby Calves NVD Form submitted successfully!');
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <FormSection>
            <FormField>
              <label>NVD No:</label>
              <input
                type="text"
                name="nvd-number"
                value={formData.nvdNumber}
                onChange={(e) => handleInputChange('nvdNumber', e.target.value)}
                placeholder="Enter NVD Number (e.g., BC0720)"
                required
              />
            </FormField>

            <FormSection className="part-a-section">
              <h3 className="section-title">Part A - Owner Details</h3>
              <p className="section-subtitle">
                To be completed by the owner or person who is responsible for the husbandry of the
                calves
              </p>

              <div className="subsection">
                <h4 className="subsection-title">Owner of the calves</h4>
                <FormField>
                  <label>Name *</label>
                  <input
                    type="text"
                    name="owner-name"
                    value={formData.ownerName}
                    onChange={(e) => handleInputChange('ownerName', e.target.value)}
                    placeholder="Enter owner name (e.g., David Grazier)"
                    required
                  />
                </FormField>
                <FormField>
                  <label>Full Trading Name</label>
                  <input
                    type="text"
                    name="full-trading-name"
                    value={formData.fullTradingName}
                    onChange={(e) => handleInputChange('fullTradingName', e.target.value)}
                    placeholder="Enter full trading name (e.g., Wintergreen Pastoral Co.)"
                  />
                </FormField>
              </div>

              <div className="subsection">
                <h4 className="subsection-title">Property/place where the journey commenced</h4>
                <TwoColumns>
                  <FormField>
                    <label>Address *</label>
                    <input
                      type="text"
                      name="property-address"
                      value={formData.propertyAddress}
                      onChange={(e) => handleInputChange('propertyAddress', e.target.value)}
                      placeholder="Enter property address (e.g., Wintergreen RMB 123)"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>Town/Suburb *</label>
                    <input
                      type="text"
                      name="property-town"
                      value={formData.propertyTown}
                      onChange={(e) => handleInputChange('propertyTown', e.target.value)}
                      placeholder="Enter town/suburb (e.g., Warren)"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>State *</label>
                    <select
                      name="property-state"
                      value={formData.propertyState}
                      onChange={(e) => handleInputChange('propertyState', e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      <option value="NSW">NSW</option>
                      <option value="VIC">VIC</option>
                      <option value="QLD">QLD</option>
                      <option value="WA">WA</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="NT">NT</option>
                      <option value="ACT">ACT</option>
                    </select>
                  </FormField>
                  <FormField>
                    <label>Postcode</label>
                    <input
                      type="text"
                      name="property-postcode"
                      value={formData.propertyPostcode}
                      onChange={(e) => handleInputChange('propertyPostcode', e.target.value)}
                      placeholder="Enter postcode"
                    />
                  </FormField>
                </TwoColumns>
                <FormField>
                  <label>Property Identification Code (PIC) of this property *</label>
                  <input
                    type="text"
                    name="property-pic"
                    value={formData.propertyPIC}
                    onChange={(e) => handleInputChange('propertyPIC', e.target.value)}
                    placeholder="Enter Property Identification Code (e.g., NA123456)"
                    required
                  />
                </FormField>
              </div>
            </FormSection>
          </FormSection>
        );

      case 1:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Description of calves</h3>
            </FormHeader>

            <TableWrapper>
              <CattleTable>
                <thead>
                  <tr>
                    <th>Number</th>
                    <th>Description (BREED, SEX, E.G. (FRIESIAN MIXED SEX))</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.calvesDescription.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          value={row.number}
                          onChange={(e) =>
                            handleCalvesDescriptionChange(index, 'number', e.target.value)
                          }
                          placeholder="Qty (e.g., 12)"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.description}
                          onChange={(e) =>
                            handleCalvesDescriptionChange(index, 'description', e.target.value)
                          }
                          placeholder="e.g., Friesian Bull Calves"
                        />
                      </td>
                      <td>
                        <FormButton
                          type="button"
                          onClick={() => removeCalvesRow(index)}
                          className="remove-btn"
                          disabled={formData.calvesDescription.length === 1}
                        >
                          Remove
                        </FormButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </CattleTable>
            </TableWrapper>

            <FormButton type="button" onClick={addCalvesRow}>
              + Add Row
            </FormButton>

            <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
              <p>
                <strong>Total:</strong> Use the Attachment Forms for consignments that require more
                lines to describe the stock. (See Explanatory Notes)
              </p>
            </div>
          </FormSection>
        );

      case 2:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Consignment Details</h3>
            </FormHeader>

            <FormField>
              <label>Consigned to *</label>
              <input
                type="text"
                name="consigned-to"
                value={formData.consignedTo}
                onChange={(e) => handleInputChange('consignedTo', e.target.value)}
                placeholder="Enter consignee name (e.g., John Burrows, Burrows Livestock Agency)"
                required
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Town/Suburb *</label>
                <input
                  type="text"
                  name="destination-town"
                  value={formData.destinationTown}
                  onChange={(e) => handleInputChange('destinationTown', e.target.value)}
                  placeholder="Enter town/suburb (e.g., Warren)"
                  required
                />
              </FormField>
              <FormField>
                <label>State *</label>
                <select
                  name="destination-state"
                  value={formData.destinationState}
                  onChange={(e) => handleInputChange('destinationState', e.target.value)}
                  required
                >
                  <option value="">Select State</option>
                  <option value="NSW">NSW</option>
                  <option value="VIC">VIC</option>
                  <option value="QLD">QLD</option>
                  <option value="WA">WA</option>
                  <option value="SA">SA</option>
                  <option value="TAS">TAS</option>
                  <option value="NT">NT</option>
                  <option value="ACT">ACT</option>
                </select>
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Address *</label>
              <input
                type="text"
                name="destination-address"
                value={formData.destinationAddress}
                onChange={(e) => handleInputChange('destinationAddress', e.target.value)}
                placeholder="Enter destination address (e.g., 12 Main St)"
                required
              />
            </FormField>

            <FormField>
              <label>Destination (if different) of calves</label>
              <input
                type="text"
                name="destination-different"
                value={formData.destinationDifferent}
                onChange={(e) => handleInputChange('destinationDifferent', e.target.value)}
                placeholder="e.g., Warren Saleyards, 50 Saleyards Rd, Warren, NSW"
              />
            </FormField>

            <FormField>
              <label>Destination PIC (REQ: WA & TAS)</label>
              <input
                type="text"
                name="destination-pic"
                value={formData.destinationPIC}
                onChange={(e) => handleInputChange('destinationPIC', e.target.value)}
                placeholder="Enter destination PIC (e.g., NA345678)"
              />
            </FormField>
          </FormSection>
        );

      case 3:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">
                Details of other statutory documents relating to this movement
              </h3>
              <p className="section-subtitle">e.g. health statement</p>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Document Type</label>
                <input
                  type="text"
                  name="document-type"
                  value={formData.documentType}
                  onChange={(e) => handleInputChange('documentType', e.target.value)}
                  placeholder="Enter document type"
                />
              </FormField>
              <FormField>
                <label>Number</label>
                <input
                  type="text"
                  name="document-number"
                  value={formData.documentNumber}
                  onChange={(e) => handleInputChange('documentNumber', e.target.value)}
                  placeholder="Enter document number"
                />
              </FormField>
            </TwoColumns>

            <TwoColumns>
              <FormField>
                <label>Office of Issue</label>
                <input
                  type="text"
                  name="office-of-issue"
                  value={formData.officeOfIssue}
                  onChange={(e) => handleInputChange('officeOfIssue', e.target.value)}
                  placeholder="Enter office of issue"
                />
              </FormField>
              <FormField>
                <label>Expiry Date</label>
                <input
                  type="date"
                  name="expiry-date"
                  value={formData.expiryDate}
                  onChange={(e) => handleInputChange('expiryDate', e.target.value)}
                />
              </FormField>
            </TwoColumns>
          </FormSection>
        );

      case 4:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 1-2</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                1. Have these calves been raised on a licensed dairy farm or consistent with the
                rules of an independently audited QA program on the property the PIC of which is
                shown above?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="licensed-dairy-farm"
                    value="yes"
                    checked={formData.licensedDairyFarm === 'yes'}
                    onChange={(e) => handleInputChange('licensedDairyFarm', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="licensed-dairy-farm"
                    value="no"
                    checked={formData.licensedDairyFarm === 'no'}
                    onChange={(e) => handleInputChange('licensedDairyFarm', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.licensedDairyFarm === 'yes' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If Yes, give details:</label>
                  <input
                    type="text"
                    value={formData.programDetails}
                    onChange={(e) => handleInputChange('programDetails', e.target.value)}
                    placeholder="Name of program and accreditation or licence no. (e.g., DFS 1 2 3 4 5 6)"
                    style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                  />
                </div>
              )}
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                2. Has the owner stated above owned these cattle since their birth?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="ownership-birth"
                    value="yes"
                    checked={formData.ownershipSinceBirth === 'yes'}
                    onChange={(e) => handleInputChange('ownershipSinceBirth', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="ownership-birth"
                    value="no"
                    checked={formData.ownershipSinceBirth === 'no'}
                    onChange={(e) => handleInputChange('ownershipSinceBirth', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.ownershipSinceBirth === 'no' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If No, how long were the calves obtained or purchased?</label>
                  <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="time-obtained"
                        value="less-than-1-week"
                        checked={formData.timeObtained === 'less-than-1-week'}
                        onChange={(e) => handleInputChange('timeObtained', e.target.value)}
                      />
                      <span className="radio-label">Less than 1 week</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="time-obtained"
                        value="more-than-1-week"
                        checked={formData.timeObtained === 'more-than-1-week'}
                        onChange={(e) => handleInputChange('timeObtained', e.target.value)}
                      />
                      <span className="radio-label">More than 1 week</span>
                    </label>
                  </div>
                </div>
              )}
            </QuestionGroup>
          </FormSection>
        );

      case 5:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 3-4</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                3. In the past 60 days, have any of the calves in this consignment consumed any
                material that was still within a withholding period when harvested, collected or
                first grazed?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="yes"
                    checked={formData.materialConsumed60Days === 'yes'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="no"
                    checked={formData.materialConsumed60Days === 'no'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.materialConsumed60Days === 'yes' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If Yes, give details:</label>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Chemical product</label>
                      <input
                        type="text"
                        value={formData.chemicalProduct}
                        onChange={(e) => handleInputChange('chemicalProduct', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Date applied</label>
                      <input
                        type="date"
                        value={formData.dateApplied}
                        onChange={(e) => handleInputChange('dateApplied', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Grazing date</label>
                      <input
                        type="date"
                        value={formData.grazingDate}
                        onChange={(e) => handleInputChange('grazingDate', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Date first pastured</label>
                      <input
                        type="date"
                        value={formData.dateFirstPastured}
                        onChange={(e) => handleInputChange('dateFirstPastured', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>
                        Date feeding/grazing ceased
                      </label>
                      <input
                        type="date"
                        value={formData.dateFeedingCeased}
                        onChange={(e) => handleInputChange('dateFeedingCeased', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                4. Have any of the calves in this consignment been treated orally, externally or by
                intramammary, intramuscular or subcutaneous injection with a veterinary drug or
                chemical, including medicated feeds? (See Explanatory Notes)
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="oral-treatment"
                    value="yes"
                    checked={formData.oralTreatment === 'yes'}
                    onChange={(e) => handleInputChange('oralTreatment', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="oral-treatment"
                    value="no"
                    checked={formData.oralTreatment === 'no'}
                    onChange={(e) => handleInputChange('oralTreatment', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.oralTreatment === 'yes' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If Yes, list details in the following space provided</label>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>
                        Veterinary Drug/Chemical
                      </label>
                      <input
                        type="text"
                        value={formData.veterinaryDrugDetails}
                        onChange={(e) => handleInputChange('veterinaryDrugDetails', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Case Treatment Date</label>
                      <input
                        type="date"
                        value={formData.caseNumber}
                        onChange={(e) => handleInputChange('caseNumber', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Date List</label>
                      <input
                        type="date"
                        value={formData.dateList}
                        onChange={(e) => handleInputChange('dateList', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </QuestionGroup>
          </FormSection>
        );

      case 6:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 5-7</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                5. Have any of the calves in this consignment had access to milk from cows that had
                been treated orally, externally or by intramammary, intramuscular or subcutaneous
                injection with a veterinary drug or chemical, before the milk withholding period has
                expired? (See Explanatory Notes)
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="milk-access"
                    value="yes"
                    checked={formData.milkAccess === 'yes'}
                    onChange={(e) => handleInputChange('milkAccess', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="milk-access"
                    value="no"
                    checked={formData.milkAccess === 'no'}
                    onChange={(e) => handleInputChange('milkAccess', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.milkAccess === 'yes' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If Yes, list details in the following space provided</label>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Vet Drug/Chemical</label>
                      <input
                        type="text"
                        value={formData.vetDrugChemical}
                        onChange={(e) => handleInputChange('vetDrugChemical', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>
                        Date calf had access to contaminated milk
                      </label>
                      <input
                        type="date"
                        value={formData.dateCalf}
                        onChange={(e) => handleInputChange('dateCalf', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>
                        Milk Withholding period
                      </label>
                      <input
                        type="text"
                        value={formData.milkWithheld}
                        onChange={(e) => handleInputChange('milkWithheld', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>Cow Days</label>
                      <input
                        type="text"
                        value={formData.cowDays}
                        onChange={(e) => handleInputChange('cowDays', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666' }}>ESI (if SET)</label>
                      <input
                        type="text"
                        value={formData.esiOrSet}
                        onChange={(e) => handleInputChange('esiOrSet', e.target.value)}
                        style={{ width: '100%', padding: '6px', fontSize: '12px' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                6. In the past 6 months have any of these animals been on a property listed on the
                ERP database or placed under any restrictions because of chemical residues?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="chemical-residues-6months"
                    value="yes"
                    checked={formData.chemicalResidues6Months === 'yes'}
                    onChange={(e) => handleInputChange('chemicalResidues6Months', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="chemical-residues-6months"
                    value="no"
                    checked={formData.chemicalResidues6Months === 'no'}
                    onChange={(e) => handleInputChange('chemicalResidues6Months', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              {formData.chemicalResidues6Months === 'yes' && (
                <div style={{ marginTop: '15px' }}>
                  <label>If Yes, give details:</label>
                  <input
                    type="text"
                    value={formData.residueDetails}
                    onChange={(e) => handleInputChange('residueDetails', e.target.value)}
                    placeholder="Provide details of restrictions"
                    style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                  />
                </div>
              )}
            </QuestionGroup>

            <FormField className="full-width">
              <label>
                7. Please include any additional information below (See Explanatory Notes)
              </label>
              <textarea
                name="additional-info"
                value={formData.additionalInfo}
                onChange={(e) => handleInputChange('additionalInfo', e.target.value)}
                rows={4}
                placeholder="Enter any additional information..."
              />
            </FormField>
          </FormSection>
        );

      case 7:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Declaration</h3>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Full Name *</label>
                <input
                  type="text"
                  name="declarant-name"
                  value={formData.declarantName}
                  onChange={(e) => handleInputChange('declarantName', e.target.value)}
                  placeholder="Enter full name (e.g., David Grazier)"
                  required
                />
              </FormField>
              <FormField>
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  placeholder="Enter phone number (e.g., 02 9463 9000)"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Full Address *</label>
              <input
                type="text"
                name="declarant-address"
                value={formData.declarantAddress}
                onChange={(e) => handleInputChange('declarantAddress', e.target.value)}
                placeholder="Enter full address (e.g., Coonamble Rd Warren)"
                required
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Fax</label>
                <input
                  type="tel"
                  name="fax"
                  value={formData.fax}
                  onChange={(e) => handleInputChange('fax', e.target.value)}
                  placeholder="Enter fax number (e.g., 02 9463 9111)"
                />
              </FormField>
              <FormField>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  placeholder="Enter email address (e.g., dgrazier@email.com.au)"
                />
              </FormField>
            </TwoColumns>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Declaration Statement</h4>
                <p>
                  I declare that, I am the owner or the person responsible for the husbandry of the
                  calves and that all the information in Part A of this document is true and
                  correct. I also declare that I have read and understood all the questions that I
                  have answered, that I have read and understood the explanatory notes, and that,
                  while under my control, the calves were not fed restricted animal material
                  (including meat and bone meal) in breach of any State or Territory legislation.
                </p>
                <p style={{ marginTop: '10px' }}>
                  I further declare that the calves in this consignment meet the animal welfare
                  requirements being they are at least in their fifth (5) day of life, are fit and
                  strong enough to be transported for sale or slaughter, and that they can feed milk
                  or red milk alone or in conjunction with other milk in the 48 hours of transport,
                  and that, while under my control, the calves were not fed restricted animal
                  material (including meat and bone meal) in breach of any State or Territory
                  legislation.
                </p>
              </div>

              <TwoColumns>
                <FormField>
                  <label>Signature *</label>
                  <input
                    type="text"
                    name="signature"
                    value={formData.signature}
                    onChange={(e) => handleInputChange('signature', e.target.value)}
                    placeholder="Digital signature or name"
                    required
                  />
                </FormField>
                <FormField>
                  <label>Date *</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={(e) => handleInputChange('date', e.target.value)}
                    required
                  />
                </FormField>
              </TwoColumns>

              <div style={{ marginTop: '15px', fontSize: '12px', color: '#666' }}>
                <p>
                  <strong>Tel no.</strong> {formData.phone}
                </p>
                <p>
                  <strong>Email.</strong> {formData.email}
                </p>
              </div>
            </DeclarationContainer>
          </FormSection>
        );

      case 8:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part B - Transport Details</h3>
              <p className="section-subtitle">
                To be completed by the person in charge of the calves while they are being moved.
                Completion of this part is optional in VIC.
              </p>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Movement commenced (Date/Time)</label>
                <input
                  type="datetime-local"
                  name="movement-commenced"
                  value={formData.movementCommenced}
                  onChange={(e) => handleInputChange('movementCommenced', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Vehicle registration number(s)</label>
                <input
                  type="text"
                  name="vehicle-registration"
                  value={formData.vehicleRegistration}
                  onChange={(e) => handleInputChange('vehicleRegistration', e.target.value)}
                  placeholder="Enter vehicle registration"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Name of person in charge of the calves during the movement</label>
              <input
                type="text"
                name="transporter-name"
                value={formData.transporterName}
                onChange={(e) => handleInputChange('transporterName', e.target.value)}
                placeholder="I am the person in charge of the calves during the movement and declare all the information in Part B is true and correct."
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Signature</label>
                <input
                  type="text"
                  name="transporter-signature"
                  value={formData.transporterSignature}
                  onChange={(e) => handleInputChange('transporterSignature', e.target.value)}
                  placeholder="Digital signature or name"
                />
              </FormField>
              <FormField>
                <label>Date</label>
                <input
                  type="date"
                  name="transporter-date"
                  value={formData.transporterDate}
                  onChange={(e) => handleInputChange('transporterDate', e.target.value)}
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Tel no.</label>
              <input
                type="tel"
                name="transporter-tel"
                value={formData.transporterTelNo}
                onChange={(e) => handleInputChange('transporterTelNo', e.target.value)}
                placeholder="Enter telephone number"
              />
            </FormField>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Transport Declaration</h4>
                <p>
                  I am the person in charge of the calves during the movement and declare all the
                  information in Part B is true and correct.
                </p>
              </div>
            </DeclarationContainer>

            <div
              style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '4px',
              }}
            >
              <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
                <strong>Please Note:</strong> In the case of calves sold at auction, this
                declaration is to be retained (original, scanned copy or summary) by the selling
                agent for a minimum of two (2) years, or three (3) years in WA. A copy is to be made
                available to any buyer of the consignment, or part of the consignment, on request.
              </p>
            </div>
          </FormSection>
        );

      default:
        return null;
    }
  };

  return (
    <CattleNvdWrapper>
      <FormTopHeader>
        <FormTitle>National Vendor Declaration (Bobby Calves) and Waybill</FormTitle>
        <p className="subtitle">
          For calves between 5 and 30 days of age not accompanied by their dam
        </p>
      </FormTopHeader>

      <form onSubmit={handleSubmit}>
        <ButtonsWrapper>
          {currentStep > 0 && (
            <OutlineButton type="button" onClick={prevStep} style={{ maxWidth: 'fit-content' }}>
              ← Back
            </OutlineButton>
          )}

          <div style={{ textAlign: 'center', flex: 1 }}>
            <span style={{ color: '#181A3B', fontSize: '14px' }}>
              Step {currentStep + 1} of {steps.length}: {steps[currentStep]}
            </span>
          </div>

          {currentStep < steps.length - 1 ? (
            <OutlineButton type="button" onClick={nextStep}>
              Next →
            </OutlineButton>
          ) : (
            <OutlineButton type="submit">Submit NVD</OutlineButton>
          )}
        </ButtonsWrapper>

        <div className="form-content">{renderStep()}</div>
      </form>
    </CattleNvdWrapper>
  );
};

export default BobbyCalvesNvd;
